import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";
import { GET_ORGANIZATION_APPS } from "../organization/getOrganizationApps";

const DELETE_APP = gql(`
    mutation DELETE_APP($appSlug: String!,$organizationSlug: String!  ) {
    appDelete(input: {appSlug:$appSlug,organizationSlug:$organizationSlug}) {
        appSlug
        organizationSlug
        __typename
    }
    }
`);

export function useDeleteApp() {
  return useMutation(DELETE_APP, { refetchQueries: [GET_ORGANIZATION_APPS] });
}
